<button mat-icon-button [matTooltip]="tooltip">
  <mat-icon>info</mat-icon>
</button>
